var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewport-panel--page"},[_c('div',{staticClass:"sidebar"},[_c('sidebar-menu',{on:{"node-click":_vm.handleNodeClick}})],1),_c('div',{staticClass:"content"},[_c('report-content',{attrs:{"url":_vm.url}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }